var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0126 5.42675C15.696 4.74333 16.804 4.74333 17.4874 5.42675L18.5732 6.51254C19.2566 7.19595 19.2566 8.30399 18.5732 8.98741L9.96358 17.5971C9.75328 17.8074 9.49286 17.9606 9.2069 18.0423L5.95606 18.9711C5.69416 19.046 5.41229 18.9729 5.21969 18.7803C5.02709 18.5877 4.95405 18.3059 5.02887 18.044L5.95769 14.7931C6.03939 14.5072 6.19262 14.2467 6.40292 14.0364L15.0126 5.42675ZM16.4268 6.48741C16.3291 6.38978 16.1708 6.38978 16.0732 6.48741L14.8106 7.74997L16.25 9.18931L17.5126 7.92675C17.6102 7.82912 17.6102 7.67083 17.5126 7.5732L16.4268 6.48741ZM15.1893 10.25L13.75 8.81063L7.46358 15.0971C7.43354 15.1271 7.41165 15.1643 7.39997 15.2052L6.84203 17.158L8.79482 16.6C8.83567 16.5884 8.87287 16.5665 8.90292 16.5364L15.1893 10.25Z",
    fill: "#C7CBE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.027ce4ae882df242a5aa1bec0ea3e811.svg";
export { ForwardRef as ReactComponent };